import { render, staticRenderFns } from "./ResearchIndex.vue?vue&type=template&id=d28cea34&scoped=true"
import script from "./ResearchIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResearchIndex.vue?vue&type=style&index=0&id=d28cea34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28cea34",
  null
  
)

export default component.exports